import React from "react";
import { MetricCard } from "../../../ForBrands/ui/BrandUI";
import { MobileKpiTile } from "../../../ForBrands/ui/mobile/MobileUI";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";
import { EMPTY_VALUE, NO_30D_HISTORY, fmtMoneyCompact, fmtSigned, plural } from "../coachUtils";

// Team KPI strip (Figma 02 · Team Roster labels, on every Team tab). Phones
// (2407:916): the 2 x 2 grid of KPI tiles, Total CacheValue muted.
const TeamKpiStrip = ({ summary, totals }) => {
  const phone = usePhoneTheme();
  const tiles = [
    { label: "Total CacheValue", value: fmtMoneyCompact(summary.cacheValueTotal), sub: plural(totals.activated ?? 0, "activated profile"), muted: true },
    {
      label: "Avg. CacheScore",
      value: summary.avgScore ?? EMPTY_VALUE,
      sub: summary.avgScoreDelta != null ? `${fmtSigned(summary.avgScoreDelta)} in 30 days` : NO_30D_HISTORY,
    },
    { label: "Total NILx Value", value: fmtMoneyCompact(summary.nilxPool), sub: "across active profiles" },
    { label: "NIL readiness", value: `${summary.readinessLinked ?? 0} of ${totals.total ?? 0}`, sub: "social accounts linked" },
  ];
  if (phone) {
    return (
      <div className="grid grid-cols-2 gap-3">
        {tiles.map((t) => (
          <MobileKpiTile key={t.label} label={t.label} value={t.value} sub={t.sub} muted={t.muted} />
        ))}
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {tiles.map((t) => (
        <MetricCard key={t.label} muted={t.muted} label={t.label} value={t.value} sub={t.sub} />
      ))}
    </div>
  );
};

export default TeamKpiStrip;
